/**
 * session.ts — in-memory session id.
 *
 * Contract (§3, §6, §10):
 *   - Random, minted once per JS runtime lifetime.
 *   - NEVER written to localStorage, sessionStorage, IndexedDB, or a cookie.
 *   - NEVER the Firebase auth UID.
 *   - Survives tab-focus changes; reset only on full page reload (which is fine —
 *     a true new session on reload is the right semantics for analytics).
 */

let _sessionId: string | null = null;

/** Returns the current session id, minting it lazily on first call. */
export function getSessionId(): string {
  if (_sessionId === null) {
    _sessionId = crypto.randomUUID();
  }
  return _sessionId;
}

/**
 * Reset the session id (used in tests to simulate a fresh page load).
 * Must NOT be called from production code.
 */
export function _resetSessionIdForTest(): void {
  _sessionId = null;
}
